export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";

export function isBreakpoint(value: string): value is Breakpoint {
    return ["xs", "sm", "md", "lg", "xl"].includes(value);
}
